<template>
  <span class="chip" :class="{ 'has-addons': removable }">
    <component
      :is="href ? 'a' : 'span'"
      v-tooltip="tooltip"
      class="tag is-rounded"
      :class="tagClasses"
      :href="href || undefined"
      :target="href ? '_blank' : undefined"
      :rel="href ? 'noopener noreferrer' : undefined"
    >
      <slot>{{ label }}</slot>
      <span v-if="href" class="icon is-small ml-1">
        <i class="fa-solid fa-arrow-up-right-from-square fa-2xs" />
      </span>
    </component>
    <a
      v-if="removable"
      v-tooltip="removeTooltip"
      class="tag is-delete is-rounded"
      :class="tagClasses"
      @click="$emit('remove')"
    />
  </span>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'Chip',
  props: {
    label: { type: [String, Number], default: '' },
    href: { type: String, default: '' },
    color: { type: String, default: 'primary' },
    light: { type: Boolean, default: false },
    removable: { type: Boolean, default: false },
    size: { type: String, default: null },
    tooltip: { type: String, default: '' },
    removeTooltip: { type: String, default: 'Remove' },
  },
  emits: ['remove'],
  setup(props) {
    const tagClasses = computed(() => {
      const classes = [`is-${props.color}`]
      if (props.light) classes.push('is-light')
      if (props.size) classes.push(`is-${props.size}`)
      return classes
    })

    return { tagClasses }
  },
}
</script>

<style lang="scss" scoped>
.chip {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: stretch;
  margin-bottom: 0;

  // When has-addons, join the tag and delete button
  &.has-addons .tag:first-child:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  &.has-addons .tag:last-child:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    margin-left: -1px;
  }
}

.tag.is-delete {
  cursor: pointer;
  transition: opacity var(--transition-fast, 150ms ease);

  &:hover {
    opacity: 0.8;
  }
}

.tag .icon {
  opacity: 0.5;
}
</style>
